<div class="container-fluid bg-light px-4 py-5 px-md-5">
    <div class="row g-5 g-sm-0 g-xl-4">
        <div class="col-12 col-xl-5 col-xxl-4 mb-lg-3 mb-xl-0">
            <div class="fs-2 fw-bold ff-spectral text-primary text-center text-xl-start mb-4 mb-xl-3">
                Premium stone. <br class="d-none d-md-block d-xxl-none"> Expertly crafted.
            </div>
            <div class="text-center text-xl-start mb-4 mb-xl-3">
                Take a look at our brand film to see how our
                York Stone goes from the quarry to your project!
            </div>
            <div class="d-flex justify-content-center justify-content-xl-start w-100 mb-4 mb-lg-0">
                <a [href]="'/why-choose-us'" class="btn btn-white fw-bold">
                    Watch our film
                </a>
            </div>
        </div>
        <div class="col-12 col-xl-7 col-xxl-7 offset-xxl-1 ps-xl-5 ps-xxl-0">
            <div class="d-flex justify-content-between align-items-center h-100">
                <div
                    class="row g-5 g-sm-0 row-icons">
                    <div class="col-6 col-sm-3 d-flex flex-column text-center justify-content-center align-items-center h-100 mt-xl-0">
                        <a href="https://www.yorkstonesupplies.co.uk/why-choose-us" class="mt-auto">
                            <svg-icon src="assets/images/icon-uk-bold.svg"
                                      [svgClass]="'icon-customer-comfort icon-customer-comfort-1'"></svg-icon>
                        </a>
                        <div class="ff-spectral fw-bold text-primary mt-3 mt-xl-auto">
                            Born in <br class="d-none d-sm-block">Britain</div>
                    </div>
                    <div
                        class="col-6 col-sm-3 d-flex flex-column text-center justify-content-center align-items-center h-100 mt-xl-0">
                        <a href="https://www.yorkstonesupplies.co.uk/delivery-information" class="mt-auto">
                            <svg-icon src="assets/images/icon-delivery-bold.svg"
                                      [svgClass]="'icon-customer-comfort icon-customer-comfort-2'"></svg-icon>

                        </a>
                        <div class="ff-spectral fw-bold text-primary mt-3 mt-xl-auto">
                            Nationwide <br class="d-none d-sm-block">Delivery*</div>
                    </div>
                    <div
                        class="col-6 col-sm-3 d-flex flex-column text-center justify-content-center align-items-center h-100 mt-xl-0">
                        <a href="https://www.yorkstonesupplies.co.uk/help/quality-guarantee" class="mt-auto">
                            <svg-icon src="assets/images/icon-guarantee-bold.svg"
                                      [svgClass]="'icon-customer-comfort icon-customer-comfort-3'"></svg-icon>

                        </a>
                        <div class="ff-spectral fw-bold text-primary mt-3 mt-xl-auto">
                            Guaranteed <br class="d-none d-sm-block">Quality</div>
                    </div>
                    <div
                        class="col-6 col-sm-3 d-flex flex-column text-center justify-content-center align-items-center h-100 mt-xl-0">
                        <a href="https://www.yorkstonesupplies.co.uk/trade" class="mt-auto">
                            <svg-icon src="assets/images/icon-diamond.svg"
                                      [svgClass]="'icon-customer-comfort icon-customer-comfort--diamond'"></svg-icon>

                        </a>
                        <div class="ff-spectral fw-bold text-primary mt-3 mt-xl-auto">
                            Exclusive <br class="d-none d-sm-block">trade benefits</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
